import {Component} from 'san';
import styles from './style/index.module.less';

export default class Header extends Component {
    static template = require('./index.html');
    static computed = {
        itemData() {
            return this.data.get('data.itemData');
        },
        info() {
            return this.data.get('data.itemData.info');
        },
        infoB() {
            return this.data.get('data.itemData.infoBaiJiaHao');
        }
    };
    initData() {
        return {
            styles
        };
    }
};
